<template>
    <div>
        <a href="" class="product-link" @click.prevent="storeSizes = true">{{ label }}</a>

        <q-dialog v-model="storeSizes"
                  transition-show="scale"
                  transition-hide="scale"
                  :maximized="$q.platform.is.mobile">
            <q-card class="modal-store-sizes modal-30">
                <div class="modal-header">
                    <span class="modal-title">{{ label }}</span>
                    <div class="modal-close" @click="storeSizes=false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div v-for="store in stores" class="store-size-container row">
                        <div class="col-12 col-sm-6 flex items-center">
                            <span class="store-name">{{ store.name }}</span>
                        </div>
                        <div v-if="sizesExist(store)" class="col-12 col-sm-6 product-size-items">
                            <div v-for="{ size } in store.sizes" class="product-size-item">{{ size }}</div>
                        </div>
                    </div>
<!--                    <table class="table">
                        <tbody>
                            <tr v-for="store in stores">
                                <td>
                                    <span class="store-name">{{ store.name }}</span>
                                    <div v-if="sizesExist(store)" class="product-size-items">
                                        <div v-for="{ size } in store.sizes" class="product-size-item"
                                             :class="{ 'product-size-item-long': size.length > 4 }">{{ size }}</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>-->
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    export default {
        name: 'StoreSizes',
        props: {
            stores: {
                type: Array,
                required: true,
            },
            label: {
                type: String,
            }
        },
        data () {
            return {
                storeSizes: false,
            }
        },
        methods: {
            sizesExist (store) {
                return store.sizes.filter(s => s.size).length;
            }
        }
    }
</script>
